import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
//primeReact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
//components
import Input from "../../../../../../components/input/Input";
import NumberInput from "../../../../../../components/input/NumberInput";
import CalendarInput from "../../../../../../components/input/CalendarInput";
//imports
import { differenceInDays } from "date-fns";
import Toggle from "../../../../../../components/button/Toggle";
import { updateParcels } from "../../../../../../services/Parcel/updateParcel";
import { useParcelContext } from "./ParcelContext";

const ModalUpdateInstallments = () => {
  const {
    control,
    handleSubmit: handleUpdateParcel,
    reset: resetUpdateParcel,
    errors,
    getValues,
    setValue,
  } = useForm();

  const [isUpdateDate, setIsUpdateDate] = useState(null);

  const {
    itemsSelected,
    setItemsSelected,

    setSelectAll,

    isModalVisibleUpdateInstallments,
    setIsModalVisibleUpdateInstallments,

    refetch,
  } = useParcelContext();

  //Função para calcular e atualizar o "Valor Atualizado"
  const updateUpdatedValue = (selected) => {
    const fieldsToSum = ["value", "fine", "fees", "honorary"];
    const newValue = fieldsToSum.reduce((acc, field) => {
      const fieldName = `${field}_id_${selected.id}`;
      const fieldValue = parseFloat(getValues(fieldName)) || 0;
      return acc + fieldValue;
    }, 0);
    setValue(`updated_value_id_${selected.id}`, newValue.toFixed(2));
  };

  const style = {
    width: window.innerWidth <= 992 ? "95vw" : "95vw",
  };

  function sendUpdate(data) {
    let installments = [];
    let index = 1;
    let currentDate = new Date(data.due_date_update);
    let sameDate = data.sameDate;

    if (sameDate == undefined) {
      sameDate = true;
    }

    // Nova variável para armazenar os campos atualizados
    const newData = {};
    for (const key in data) {
      const selectedItem = itemsSelected.find(
        (item) => item.id === parseInt(key.split("_")[2])
      );
      if (selectedItem) {
        newData[key] = data[key];
      }
    }

    for (const key in newData) {
      if (key.startsWith("value_id_")) {
        const id = key.split("_")[2];
        const installment = {
          id: parseInt(id),
          fine: parseFloat(newData[`fine_id_${id}`]),
          daily_interest_rate: parseFloat(newData[`fees_id_${id}`]),
          honorary: parseFloat(newData[`honorary_id_${id}`]) || 0,
          date: currentDate.toISOString().split("T")[0],
        };
        installments.push(installment);
        if (!sameDate) {
          currentDate.setMonth(currentDate.getMonth() + 1);
        }
        index = Math.max(index, parseInt(id));
      }
    }
    const result = {
      action: "update_installment",
      installments: installments,
    };

    setIsModalVisibleUpdateInstallments(false);

    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    // Executa a função de atualização das parcelas
    updateParcels(result)
      .then(() => {
        // Em seguida, atualiza os itens selecionados e chama a função de refresh
        setItemsSelected([]);
        setSelectAll([]);
        resetUpdateParcel();
        return refetch();
      })
      .then(() => {
        // Depois que o refresh for concluído com sucesso, atualize a notificação para indicar sucesso
        toast.update(notification, {
          render: "Parcelas atualizadas com sucesso!",
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      })
      .catch((error) => {
        toast.update(notification, {
          render: "Não foi possível atualizar as parcelas!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao atualizar parcelas:", error);
      });
  }
  const currentDate = new Date(); // Obtém a data atual
  const getFormErrorMessage = () => { };
  useEffect(() => {
    if (itemsSelected && itemsSelected.length > 0) {
      itemsSelected.forEach((selected, index) => {
        setValue(`value_id_${selected.id}`, selected.value);

        // Calcula a quantidade de dias passados
        const dueDate = new Date(selected.due_date);
        const currentDate = new Date(); // Obtém a data atual
        const defaultDate = isUpdateDate || currentDate;
        const daysPassed = differenceInDays(defaultDate, dueDate);
        const newDueDate = new Date(dueDate);
        newDueDate.setDate(dueDate.getDate() + 1);
        setValue(`due_date_id_${selected.id}`, newDueDate);
        setValue(`amount_id_${selected.id}`, daysPassed);

        const percentualMulta = (selected.enterprise?.late_fee ?? 0) / 100; // 2%
        const percentualJurosDiario = ((selected.enterprise?.late_interest ?? 0) / 100) / 30 ; 

        const valorParcela = selected.value;

        // Calcula a multa
        const multa = daysPassed > 0 ? valorParcela * percentualMulta : 0;
        setValue(`fine_id_${selected.id}`, multa.toFixed(2));

        // Calcula os juros por atraso
        const jurosAtraso =
          daysPassed > 0
            ? valorParcela * percentualJurosDiario * daysPassed
            : 0;
        setValue(`fees_id_${selected.id}`, jurosAtraso.toFixed(2));

        const honoraryValue = parseFloat(
          getValues(`honorary_id_${selected.id}`) || 0
        );

        const total = jurosAtraso + multa + honoraryValue + valorParcela;

        setValue(`updated_value_id_${selected.id}`, total.toFixed(2));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsSelected, isUpdateDate]);
  return (
    <>
      <Dialog
        header="Atualizar Parcelas"
        id="modal_cad"
        className="rounded-4"
        onHide={() =>
          setIsModalVisibleUpdateInstallments(!isModalVisibleUpdateInstallments)
        }
        visible={isModalVisibleUpdateInstallments}
        style={style}
      >
        <Divider align="left">
          <div className="inline-flex align-items-center">
            <i className="pi pi-user mr-2"></i>
            <b> Informações das parcelas</b>
          </div>
        </Divider>
        <form onSubmit={handleUpdateParcel(sendUpdate)}>
          <div>
            <div>
              {itemsSelected.map((selected, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-center mb-3"
                  style={{ gap: '10px' }}  // Gap entre os campos
                >
                  {/* Valor da Parcela */}
                  <div className="flex-grow-1">
                    <NumberInput
                      className="p-inputtext-sm rounded-4 w-100"  // largura 100% para ajustar
                      disabled={true}
                      suffix={""}
                      mode="currency"
                      currency="BRL"
                      locale="pt-BR"
                      useGrouping={true}
                      placeholder={"0"}
                      max={undefined}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      name={`value_id_${selected.id}`}
                      control={control}
                      label="Valor da Parcela"
                    />
                  </div>

                  {/* Data de Vencimento */}
                  <div className="flex-grow-1">
                    <CalendarInput
                      disabled={true}
                      inputId={`due_date_id_${selected.id}`}
                      className="p-inputtext-sm rounded-4 w-100"
                      label="Data de Vencimento"
                      errors={errors}
                      isRequired={true}
                      control={control}
                      name={`due_date_id_${selected.id}`}
                    />
                  </div>

                  {/* Dias em Atraso */}
                  <div className="flex-grow-1">
                    <Input
                      disabled={true}
                      type="text"
                      value={10}
                      className="p-inputtext-sm rounded-4 w-100"
                      label="Dias em Atraso"
                      errors={errors}
                      isRequired={true}
                      control={control}
                      name={`amount_id_${selected.id}`}
                    />
                  </div>

                  {/* Multa */}
                  <div className="flex-grow-1">
                    <NumberInput
                      className="p-inputtext-sm rounded-4 w-100"
                      disabled={false}
                      suffix={""}
                      mode="currency"
                      currency="BRL"
                      locale="pt-BR"
                      useGrouping={true}
                      placeholder={"0"}
                      max={undefined}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      name={`fine_id_${selected.id}`}
                      control={control}
                      label="Multa"
                      onChange={(e) => updateUpdatedValue(selected)}
                    />
                  </div>

                  {/* Juros */}
                  <div className="flex-grow-1">
                    <NumberInput
                      className="p-inputtext-sm rounded-4 w-100"
                      disabled={false}
                      suffix={""}
                      mode="currency"
                      currency="BRL"
                      locale="pt-BR"
                      useGrouping={true}
                      placeholder={"0"}
                      max={undefined}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      name={`fees_id_${selected.id}`}
                      control={control}
                      label="Juros"
                      onChange={(e) => updateUpdatedValue(selected)}
                    />
                  </div>

                  {/* Honorários */}
                  <div className="flex-grow-1">
                    <NumberInput
                      className="p-inputtext-sm rounded-4 w-100"
                      disabled={false}
                      suffix={""}
                      mode="currency"
                      currency="BRL"
                      locale="pt-BR"
                      useGrouping={true}
                      placeholder={"0"}
                      max={undefined}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      defaultValue={0}
                      name={`honorary_id_${selected.id}`}
                      control={control}
                      label="Honorários"
                      onChange={(e) => updateUpdatedValue(selected)}
                    />
                  </div>

                  {/* Valor Atualizado */}
                  <div className="flex-grow-1">
                    <NumberInput
                      className="p-inputtext-sm rounded-4 w-100"
                      disabled={true}
                      suffix={""}
                      mode="currency"
                      currency="BRL"
                      locale="pt-br"
                      placeholder={"0"}
                      useGrouping={true}
                      max={undefined}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      name={`updated_value_id_${selected.id}`}
                      control={control}
                      label="Valor Atualizado"
                    />
                  </div>
                </div>
              ))}
            </div>



            <div className="d-flex justify-content-center mb-3">
              <div className="col-md-3">
                <CalendarInput
                  inputId={`due_date_update`}
                  className="p-inputtext-sm rounded-2"
                  label="Data de Atualização"
                  errors={errors}
                  onChange={(e) => setIsUpdateDate(e.value)}
                  isRequired={true}
                  control={control}
                  name={`due_date_update`}
                  minDate={currentDate}
                />
              </div>
              <div className={`col-md-2 pt-3 mx-2 ${itemsSelected.length > 1 ? "" : "d-none"}`}>
                <Toggle
                  className={"w-50"}
                  name="sameDate"
                  preValue={true}
                  onLabel="Mesma Data"
                  offLabel="Mesma Data"
                  control={control}
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
            </div>

            <div className="text-center">
              <Button
                rounded
                label="Atualizar"
                icon="fa-solid fa-wrench"
                type="submit"
                className="p-inputtext-sm m-auto"
              />
            </div>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default ModalUpdateInstallments;
